import styled, { css } from 'styled-components';

import { RowColor } from 'types';

import { pickColor } from 'themes/helpers/pickColor';

type StyledTDProps = {
  hasNoData?: boolean;
};

type StyledTRProps = {
  colors?: RowColor;
  isRowBold?: boolean;
  isClickable?: boolean;
};

const Body = styled.tbody`
  position: relative;
`;

const TR = styled.tr<StyledTRProps>`
  background-color: ${({ colors }) => pickColor(colors?.background || 'white')};
  color: ${({ colors }) => pickColor(colors?.color || 'black')};

  ${({ isRowBold }) =>
    isRowBold &&
    css`
      font-weight: bold;

      span {
        font-weight: bold;
      }
    `};

  ${({ isClickable }) =>
    isClickable &&
    css`
      cursor: pointer;

      &:hover {
        background-color: ${pickColor('gray')};
      }
    `};
`;

const TD = styled.td<StyledTDProps>`
  padding: 0.8rem;

  ${({ hasNoData }) =>
    hasNoData
      ? css`
          height: 10rem;
        `
      : null}
`;

const NoData = styled.div`
  position: absolute;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${pickColor('white')};
`;

export { Body, NoData, TD, TR };
